import { Services as CommunicationServices } from '@smiles/core-communication';

export const getComparatorPage = async () => {
  try {
    const { data } = await CommunicationServices.getProdConfigService({
      ProductConfigId: 'hotels-show-comparator-page',
    });

    // @ts-ignore
    return data.is_active;
  } catch (error) {
    console.error(error);
    return null;
  }
};
